export const environment = {
  production: false,
  apiUrl: 'https://apidev.pinturasgarciapa.com'
};
